import { Input, type EditPricingSchema } from './'
import { useFormContext } from 'react-hook-form'
import { PricingVariantList } from '../../components/pricing-variant-list'
import { useInfiniteSizeCategoryOptions } from '$hooks/use-infinite-size-category-options'
import { useInfiniteCoatTypeOptions } from '$hooks/use-infinite-coat-type-options'
import { DogBreed } from '$api-client/types.gen'

type EditPricingContentProps = {
  currency?: string
}

export function EditPricingContent({ currency }: EditPricingContentProps) {
  const { watch, setValue, formState: { errors } } = useFormContext<EditPricingSchema>()

  const variants = watch(Input.Variants) || []

  const { options: sizeOptions } = useInfiniteSizeCategoryOptions()
  const { options: coatOptions } = useInfiniteCoatTypeOptions()
  const breedOptions = Object.entries(DogBreed).map(([id, value]) => ({ id, value }))

  const addVariant = (type: 'size-coat' | 'breed') => setValue(
    Input.Variants,
    [
      ...variants,
      {
        breed: null,
        size_category: null,
        coat_type: null,
        override_type: type,
        is_default: false,
        price: 30,
        duration: 30,
      }],
  )


  const removeVariant = (index: number) => {
    setValue(Input.Variants, variants.filter((_, i) => i !== index))
  }

  const updateVariant = (index: number, field: string, value: unknown) => {
    const updated = [...variants]
    updated[index] = { ...updated[index], [field]: value }
    setValue(Input.Variants, updated)
  }

  return (
    <PricingVariantList
      variants={variants}
      fieldName={Input.Variants}
      currency={currency}
      sizeOptions={sizeOptions}
      coatOptions={coatOptions}
      breedOptions={breedOptions}
      onAdd={addVariant}
      onRemove={removeVariant}
      onDurationChange={(index, duration) => updateVariant(index, 'duration', duration)}
      error={errors[Input.Variants]?.message}
    />
  )
}
